import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {
  Box,
  Button,
  Paper,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  Chip,
  CircularProgress,
  TableFooter,
  TablePagination
} from '@material-ui/core';
import TablePaginationActions from '../Table/TablePaginationActions';

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: '#202340',
    color: theme.palette.common.white
  },
  body: {
    fontSize: 14
  }
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover
    }
  }
}))(TableRow);

function DataTable({
  tableHead,
  tableData,
  className,
  handleUpdateAPIStatus,
  handleUpdateAPICode,
  loading
}) {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, tableData.length - page * rowsPerPage);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const indexedTableData =
    tableData &&
    tableData.map((item, index) => {
      return { ...item, index: index + 1 };
    });

  // console.log('indexed ', indexedTableData);

  return (
    <TableContainer className={className.datatable} component={Paper}>
      <Table className={className.table}>
        <TableHead>
          <TableRow>
            {tableHead.map((item, index) => (
              <StyledTableCell key={index} align="center">
                {item.title}
              </StyledTableCell>
            ))}
          </TableRow>
        </TableHead>
        {!loading ? (
          <TableBody>
            {(indexedTableData.length > 0
              ? indexedTableData.slice(
                  page * rowsPerPage,
                  page * rowsPerPage + rowsPerPage
                )
              : indexedTableData
            ).map((item, index) => (
              <StyledTableRow key={index}>
                <TableCell> {item.index} </TableCell>
                <TableCell align="center"> {item.name} </TableCell>
                <TableCell align="center"> {item.userID} </TableCell>

                <TableCell align="center">
                  {' '}
                  {item.status == 0 ? (
                    <Chip
                      variant="outlined"
                      color="primary"
                      size="small"
                      label="Deactivated"
                    />
                  ) : (
                    <Chip
                      style={{ background: 'green', color: 'white' }}
                      size="small"
                      label="Active"
                    />
                  )}{' '}
                </TableCell>
                <TableCell align="center">
                  <Box style={{ display: 'flex', justifyContent: 'center' }}>
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      onClick={() => handleUpdateAPICode(item)}
                    >
                      Update API
                    </Button>
                    &nbsp;
                    <Button
                      onClick={() => handleUpdateAPIStatus(item)}
                      variant="contained"
                      color="primary"
                      size="small"
                    >
                      Update Status
                    </Button>
                  </Box>
                </TableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        ) : (
          <TableBody>
            <TableCell>
              <CircularProgress size="1rem" />
            </TableCell>
          </TableBody>
        )}
        <TableFooter>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
              colSpan={3}
              count={indexedTableData.length}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                inputProps: { 'aria-label': 'rows per page' },
                native: true
              }}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  );
}

export default DataTable;
